// extracted by mini-css-extract-plugin
export default {"container":"-h09i3YKcjuGNQI3D1V2uA==","title":"S+2ITPhKj7V4BqL8cmOOIA==","list":"jsZfFWj02cfevucQ1TcpKg==","list-item":"CJuPO5wHdPhVEkiIdNs1JA==","image":"O7qoK3ardJUxzgsJwUtK1A=="};